const $ = require("cash-dom");
const popup = require('./popup');

const Tooltip = {
    show: function (el) {
        var self = this,
          position = self.getPosition(el),
          tooltip = self.build(el),
          id = this._id();

        //apply id to link control and tooltip
        el.data("tooltip-id", id);
        tooltip.attr("data-id", id);

        if (tooltip.length > 0) {
            tooltip.css({top: 0, left: 0, display: 'block', opacity: 1});
            $(document.body).append(tooltip);

            var isFixed = el.attr('data-tooltip-fixed') === 'true',
              pos = self.getPositionData(el, isFixed),
              actualWidth = tooltip.width(),
              actualHeight = tooltip.height(),
              tp = {top: pos.top - actualHeight - 20, left: pos.left + pos.width / 2 - actualWidth / 2}; //top position

            if (isFixed) {
                tooltip.css({position: 'fixed'});
            }

            switch (position) {
                case 'bottom':
                    var left = pos.left + pos.width / 2 - actualWidth / 2;

                    //fix for the tooltip which goes over the screen to the left
                    if (left < 0) {
                        var newWidth = actualWidth + (left * 2);

                        if (newWidth / actualWidth < 0.5) {
                            newWidth = actualWidth / 2;
                        }

                        tooltip.width(newWidth);
                        left = pos.left + pos.width / 2 - newWidth / 2;
                    }

                    tp = {top: pos.top + pos.height, left: left};
                    break;
                case 'left':
                    tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth};
                    break;
                case 'right':
                    tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width};
                    break;
            }

            tooltip.css(tp);
        }
    },
    getPositionData: function (el, fixed) {
        var rect = el[0].getBoundingClientRect(),
          docEl = document.documentElement,
          scrollTop = window.pageYOffset || docEl.scrollTop || document.body.scrollTop || 0,
          scrollLeft = window.pageXOffset || docEl.scrollLeft || document.body.scrollLeft || 0;

        return {
            top: fixed ? rect.top : rect.top + scrollTop,
            left: fixed ? rect.left : rect.left + scrollLeft,
            width: rect.width || el[0].offsetWidth,
            height: rect.height || el[0].offsetHeight
        };
    },
    getPosition: function (el) {
        var self = this,
          position = el.attr('data-tooltip-position') || 'top',
          position_lg = el.attr('data-tooltip-position-lg') || position;

        if ($(window).width() >= 1500) {
            position = position_lg;
        }

        return position;
    },
    build: function (el) {
        var self = this,
          content = el.data('tooltip'),
          position = self.getPosition(el),
          is_thumb = false,
          additional_classes = '',
          data_classes = el.data('tooltip-classes');


        if (!content.length) {
            return '';
        }

        if (/^http.+\.(jpg|png)$/.test(content)) {
            is_thumb = true;
            additional_classes = 'thumbnail loading';
            content = $('<img />').attr('src', content);

        }

        if (typeof data_classes !== 'undefined' && data_classes.length) {
            additional_classes += " " + data_classes + " ";
        }

        additional_classes += " " + 'tooltip-' + position;

        var $tooltip_content = $('<div />').attr({
            class: 'simple-tooltip-content'
        }).html(content).append('<div class="simple-tooltip-arrow"></div>');

        if (is_thumb) {
            $tooltip_content.append('<div class="img-loader light-loader"></div>');
        }

        var $tooltip = $('<div />').attr({
            class: 'simple-tooltip ' + additional_classes
        }).append($tooltip_content);


        if (is_thumb) {
            content.load(function () {
                $tooltip.removeClass('loading');
            });
        }

        return $tooltip;
    },
    init: function () {
        var self = this;

        $(document).on('mouseenter', '[data-tooltip]', function () {
            if ($(this).data("tooltip-trigger") === "click") {
                return;
            }

            self.show($(this));
        }).on('mouseleave', '[data-tooltip]', function (e) {
            if ($(this).data("tooltip-trigger") === "click") {
                return;
            }

            $('.simple-tooltip').remove();
        }).on('click', '[data-tooltip]', function () {
            self.popup($(this));
        }).on('keydown', '[data-tooltip]', function (e) {
            if (e.keyCode === 13) {
                self.popup($(this));
            }
        });

        $('[data-tooltip][data-tooltip-autoshow]').each(function () {
            var $host = $(this),
              timeout = $host.attr('data-tooltip-autoshow');

            if (timeout === '') timeout = 0;

            timeout = +timeout; //convert to Number

            setTimeout(function () {
                $host.trigger('mouseenter');
            }, timeout);

            setTimeout(function () {
                $host.trigger('mouseleave');
            }, timeout + 9000);
        });

        var window_width = $(window).width();
        $(window).on("resize", function () {
            if (window_width !== $(window).width()) {
                $('[data-tooltip]').first().trigger('mouseleave');
            }
        });
    },

    popup: function ($el) {
        if ($el.data("tooltip-trigger") === "click" && $(window).width() > 992) {

            if ($(".simple-tooltip[data-id=\"" + $el.data("tooltip-id") + "\"]").length > 0) {
                $(".simple-tooltip[data-id=\"" + $el.data("tooltip-id") + "\"]").remove();
                return;
            } else {
                $(".simple-tooltip").remove();
            }

            this.show($el);
            return;
        }

        if ($(window).width() > 992) {
            return;
        }

        var content = "<div class=\"mobile-tooltip-content\">" +
          "<h3>" + $el.text() + "</h3>" +
          $el.attr('data-tooltip') + "</div>";

        popup.show(content, {className: 'tooltip-popup-container'});
    },

    _id: function () {
        return 't_' + Math.random().toString(36).substr(2, 9);
    }
};

module.exports = Tooltip;
